import { Component, OnInit } from '@angular/core';
import { ModalService } from '../../shared/services/modal.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { SampleService } from '../../core/http/sample.service';
import { SettingsService } from '../../core/http/settings.service';
import { BillingService } from '../../core/http/billing.service';
import { AuthServiceService } from '../../core/http/auth-service.service';
import { ObsService } from '../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import * as _moment from 'moment';
const moment = _moment;

@Component({
  selector: 'app-scan',
  templateUrl: './scan.component.html',
  styleUrls: ['./scan.component.scss'],
})
export class ScanComponent implements OnInit {
  dept_code = 1;
  depts: any = [];
  isLoading = true;
  isSaveLoading = false;
  mode = 'form';
  Errors = null;
  data: any = [];
  samples: any = [];
  Success;
  billId;
  message;
  sex = '';
  name = '';
  phone = '';
  record: any = [];
  templates: any = [];
  startdate = '';
  enddate = '';
  details;
  isSelected: boolean = true;
  drs: any = [];
  currentDateTime = new Date();

  Template_Text = '';

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '300px',
    minHeight: '300px',
    maxHeight: '300px',
    width: 'auto',
    minWidth: 'auto',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
    ],
    sanitize: true,
    toolbarPosition: 'top',
    toolbarHiddenButtons: [
      ['insertImage', 'insertVideo', 'insertHorizontalRule', 'removeFormat'],
    ],
  };

  stateForm = new FormGroup({
    sample_id: new FormControl('', Validators.required),
    format_code: new FormControl(''),
    formatstr: new FormControl('', Validators.required),
    result_id: new FormControl('', Validators.required),
  });

  currentPage: number = 1;
  totalSize: number = 1;
  pageSize: number = 100;
  onPageChanged(newPage: number) {
    this.getResult(newPage);
  }

  constructor(
    public router: Router,
    private obs: ObsService,
    private sample: SampleService,
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public setting: SettingsService,
    public auth: AuthServiceService,
    public bill: BillingService
  ) {}

  ngOnInit(): void {
    const currentDate = moment();
    const twoMonthsAgo = moment(currentDate).subtract(2, 'months');
    this.startdate = twoMonthsAgo.format('YYYY-MM-DD');
    this.enddate = currentDate.format('YYYY-MM-DD');
    this.setting.getDept().subscribe(
      (resSuccess) => {
        this.depts = resSuccess;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
    this.sample.getResults(this.startdate, this.enddate, this.dept_code).subscribe(
      (resSuccess: any) => {
        this.data = resSuccess.data;
        if (resSuccess.metadata) {
          this.currentPage = resSuccess.metadata.page;
          this.totalSize = resSuccess.metadata.total;
          this.pageSize = resSuccess.metadata.pagesize;
        }
        this.isLoading = false;
        console.log(resSuccess);
        console.log(this.data);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );
  }
  getResult(pageno=1) {
    this.isLoading = true;
    this.sample
      .searchResults(
        this.startdate,
        this.enddate,
        this.name,
        this.phone,
        this.sex,
        this.dept_code, 
        pageno, 
        this.pageSize
      )
      .subscribe(
        (resSuccess: any) => {
          this.data = resSuccess.data;
          if (resSuccess.metadata) {
            this.currentPage = resSuccess.metadata.page;
            this.totalSize = resSuccess.metadata.total;
            this.pageSize = resSuccess.metadata.pagesize;
          }
          this.isLoading = false;
          console.log(this.data);
        },
        (resErr) => {
          this.Errors = resErr;
          this.isLoading = false;
        }
      );
  }

  getRowClass(item: any): string {
    const typed = item.service.prepared ? item.service.prepared === 'Y' : false;

    const finalized = item.service.finalized_timestamp
      ? item.service.finalized_timestamp
      : false;
    const online = item?.pushedOnlineStatus ? item?.pushedOnlineStatus : false;
    const printed = item.service.printed ? item.service.printed === 'Y' : false;

    // Priority is defined by the order of these conditions
    if (online) return 'verified';
    if (printed) return 'printed';
    if (finalized) return 'finalized';
    if (typed) return 'prepared';

    return '';
  }

  startDateChange(event: any) {
    this.startdate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.startdate);
  }
  endDateChange(event: any) {
    this.enddate = moment(event.target.value).format('YYYY-MM-DD');
    console.log(this.enddate);
  }

  // itemChange(value) {
  //   if(value == "") {
  //     this.drVisible = false
  //   }else {
  //     this.drVisible = true
  //   }
  //   this.filterddata = this.items.filter(t => t.name.toLowerCase().indexOf(value.toLowerCase()) !== -1)
  //   console.log(value);

  // }

  getTemplate(code) {
    this.sample.getTemplate(code).subscribe(
      (resSuccess) => {
        this.templates = resSuccess;
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }

  getDetails(result_id) {
    this.sample.getdetails(result_id).subscribe(
      (resSuccess) => {
        this.details = resSuccess;
        this.Template_Text = this.details.data;
        console.log(this.details);
      },
      (resErr) => {
        this.Errors = resErr;
      }
    );
  }
  isWithinLastWeek(dateStr: string): boolean {
    const fourHoursAgo = new Date(
      this.currentDateTime.getTime() - 4 * 60 * 60 * 1000 // 4 hours in milliseconds
    );
    const targetDate = new Date(dateStr);
    return targetDate >= fourHoursAgo && targetDate <= this.currentDateTime;
  }
  addRecord(item) {
    this.record = item;
    if (
      item.service_name === 'Obstetric' ||
      item.service_name == 'OBS' ||
      item.service_name == 'PELVIC ' ||
      item.service_name == 'Pelvic Scan'
    ) {
      this.obs.addItem(item);
      this.router.navigateByUrl('/obs', { state: { patient: item } });
    } else {
      this.mode = 'wiz';
      this.Errors = '';
      this.isSelected = true;
      this.getTemplate(item.service_code);
      this.getDetails(item.result_id);
      this.stateForm.patchValue({
        sample_id: item.sample_id,
        format_code: item.format_code,
        result_id: item.result_id,
      });
    }
    console.log(item);
  }
  back() {
    this.mode = 'form';
    this.Template_Text = '';
    this.isSelected = true;
  }
  done() {
    this.mode = 'form';
    this.stateForm.patchValue({
      formatstr: this.Template_Text.replace(/"/g, "'"),
    });
    console.log(this.stateForm.value);
    this._snackBar.open('Template Added Successfully', '', {
      duration: 2000,
      verticalPosition: 'top',
    });
  }
  setTemplate(template) {
    this.Template_Text = template.Template_Text.replace(/"/g, "'");
    this.isSelected = false;
    console.log(this.Template_Text);
  }

  Submit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultDetail(result_id, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          this.getResult();
          this.stateForm.reset();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  onSubmit(e) {
    // e.preventDefault();
    console.log(this.stateForm.value);
    this.isSaveLoading = true;
    this.Errors = null;
    this.Success = null;
    const { sample_id, format_code, formatstr, result_id } =
      this.stateForm.value;
    this.sample.postResultTemplate(sample_id, format_code, formatstr).subscribe(
      (resSuccess) => {
        this.message = resSuccess;
        this.isSaveLoading = false;
        console.log(resSuccess);

        if (this.message.success) {
          this.getResult();
          this.stateForm.reset();
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.Errors = 'Not successful, please try again';
          console.log('error');
          this._snackBar.open('Error Please Try Agian', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        }
      },
      (resErr) => {
        this.isSaveLoading = false;
        this.Errors = resErr;
        this._snackBar.open('error: please try again', '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }

  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <style>
          #print-section {
            width: 500px;
          }
          </style>
        </head>
    <body onload="window.print()">${printContents}</body>
      </html>`);
    popupWin.document.close();
  }
}
